import { nullable } from '@infl-ts/util-io-ts';
import { ActivityState } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
export var GetNotificationsInput = t.partial({
  last: t.number,
  before: t.string
});
var Activity = t.type({
  id: t.string,
  state: ActivityState
});
export var Challenge = t.type({
  __typename: t.literal('Challenge'),
  id: t.string
});
export var PublicResponse = t.type({
  __typename: t.literal('PublicResponse'),
  id: t.string,
  stage: t.type({
    id: t.string,
    challenge: t.type({
      id: t.string,
      activities: nullable(t.array(Activity))
    })
  })
});
export var PublicResponseComment = t.type({
  __typename: t.literal('PublicResponseComment'),
  id: t.string,
  publicResponse: PublicResponse
});
var Notification = t.type({
  createdAt: t.string,
  description: t.string,
  iconUrl: nullable(t.string),
  id: t.string,
  title: t.string,
  unread: t["boolean"],
  eventType: t.string,
  node: nullable(t.union([t.type({
    __typename: t.string,
    id: t.string
  }), Challenge, PublicResponse, PublicResponseComment]))
});
export var GetNotificationsOutput = t.type({
  notifications: t.type({
    edges: t.array(t.type({
      cursor: t.string,
      node: Notification
    })),
    pageInfo: nullable(t.type({
      hasNextPage: t["boolean"]
    }))
  })
});
export var MarkAllNotificationsReadOutput = t.type({
  markAllNotificationsRead: t.type({
    edges: t.array(t.type({
      node: t.type({
        id: t.string
      })
    }))
  })
});